<h1 mat-dialog-title>Rename Dynamic Image Set</h1>
<mat-dialog-content>
  <div >Rename image set {{data.disId}}</div>
  <mat-form-field appearance="fill">
    <mat-label>Target name</mat-label>
    <input matInput [(ngModel)]="targetDisId">
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-button [mat-dialog-close]="true">Rename</button>
</mat-dialog-actions>
